module.exports = __webpack_public_path__ + "static/python-528c42d14a4e604f621eff18b5814536.png";